"use client";

import { openConsentBanner } from "@/lib/consent";

// Footer link that re-opens the cookie consent banner so a visitor can change
// or withdraw a previous choice (GDPR: withdrawal must be as easy as granting).
// Styled to match the footer's existing links.
const CookieSettingsLink = () => {
  return (
    <button
      type="button"
      onClick={openConsentBanner}
      className="hover:text-foreground transition"
    >
      Cookie settings
    </button>
  );
};

export default CookieSettingsLink;
